import React, {LegacyRef, MouseEventHandler, useState} from 'react';
import './CLDropDownMenu.scss';
import CLDropDownMenu, {
  CL_DROPDOWN_ANIMATION_DURATION,
  CLDropDownMenuItemProps as ItemProps,
} from './CLDropDownMenu';
import classNames from 'classnames';
import CLOverlayTrigger from '../CLOverlayTrigger/CLOverlayTrigger';
import CLMenuArrow from '../CLMenuArrow/CLMenuArrow';
import {AutomationProps} from 'common/src/modules/automation/automation.types';
import addAutomationTag from 'common/src/modules/automation/utils/addAutomationTag';

interface CLDropDownMenuItemProps extends AutomationProps {
  onClick: MouseEventHandler;
  onMouseOver?: MouseEventHandler;
  itemRef?: LegacyRef<HTMLLIElement>;
  menuItemClassName?: string;
  item: ItemProps;
  highlightOnlyActiveItems?: boolean;
}

function CLDropDownMenuItem({
  onClick,
  onMouseOver,
  menuItemClassName,
  itemRef,
  item,
  highlightOnlyActiveItems,
  qaHook = '',
}: CLDropDownMenuItemProps) {
  const [isSubMenuOpen, setIsSubMenuOpen] = useState(false);
  const element = (
    <li
      {...addAutomationTag(qaHook)}
      onClick={item.isDisabled ? null : onClick}
      onMouseOver={onMouseOver}
      className={classNames('dropdown_menu_list_item', menuItemClassName, {
        disabled: item.isDisabled,
        isLineBreak: item.isLineBreak,
        active: item.isActive,
        selected: isSubMenuOpen,
        highlight_only_active: highlightOnlyActiveItems,
      })}
      ref={itemRef}
    >
      {item.content}
      {item.subMenu && !item.hideSubMenuArrow ? (
        <CLMenuArrow
          className="sub_menu_arrow"
          startPosition={isSubMenuOpen ? 'down' : 'right'}
          size={null}
        />
      ) : null}
    </li>
  );

  return (
    <CLOverlayTrigger trigger="hover" popper={item.tooltip} key={item.id} fitContent={false}>
      {item.groupName && (
        <div className="divider_container">
          <div className="dropdown_divider" />
          <div className="group_name">{item.groupName}</div>
        </div>
      )}
      {item.subMenu && !item.isDisabled ? (
        <CLDropDownMenu
          qaHook={qaHook && `${qaHook}_sub_menu`}
          triggerElementClassName="trigger_container"
          menuItems={item.subMenu}
          placement="right-start"
          offset={[-6, 4]}
          duration={item.duration ?? CL_DROPDOWN_ANIMATION_DURATION}
          onShow={() => setIsSubMenuOpen(true)}
          onHide={() => setIsSubMenuOpen(false)}
        >
          {element}
        </CLDropDownMenu>
      ) : (
        element
      )}
    </CLOverlayTrigger>
  );
}

export default CLDropDownMenuItem;
